import { render, staticRenderFns } from "./loading-overlay.vue?vue&type=template&id=1157d82d&scoped=true&"
import script from "./loading-overlay.vue?vue&type=script&lang=js&"
export * from "./loading-overlay.vue?vue&type=script&lang=js&"
import style0 from "./loading-overlay.vue?vue&type=style&index=0&id=1157d82d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1157d82d",
  null
  
)

export default component.exports